import { takeEvery } from "redux-saga/effects";

import { ECONTRACT_AGREEMENT } from "constants/actionTypes";
import { ModalTypes } from "constants/navigation";

import { openModalLink } from "lib/navigation";

function onGenerateContractSuccess({ payload }: { payload: EContract }) {
  openModalLink(ModalTypes.EContract, { id: payload.id });
}

export default function* eContractAgreementSaga() {
  yield takeEvery(
    ECONTRACT_AGREEMENT.GENERATE_CONTRACT.SUCCESS,
    onGenerateContractSuccess,
  );
}
